type StatCardProps = {
  label: string;
  value: string;
  trend?: string;
};

function StatCard({ label, value, trend }: StatCardProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
        {label}
      </p>
      <div className="mt-3 flex items-end justify-between">
        <span className="text-2xl font-semibold text-slate-900">{value}</span>
        {trend && (
          <span className="rounded-full bg-slate-100 px-2 py-1 text-xs text-slate-500">
            {trend}
          </span>
        )}
      </div>
    </div>
  );
}

export default StatCard;
